import jscad from "@jscad/modeling";
import { geom3ToObject3D } from "./toObject3D/CsgGeom3ToObject3D";
import { geom2ToObject3D } from "./toObject3D/CsgGeom2ToObject3D";
import { path2ToObject3D } from "./toObject3D/CsgPath2ToObject3D";
export var CsgObjectType = /* @__PURE__ */ ((CsgObjectType2) => {
  CsgObjectType2["GEOM3"] = "geom3";
  CsgObjectType2["GEOM2"] = "geom2";
  CsgObjectType2["PATH2"] = "path2";
  CsgObjectType2["UNKNOWN"] = "unknown";
  return CsgObjectType2;
})(CsgObjectType || {});
export function csgObjectType(csg) {
  if (jscad.geometries.geom3.isA(csg)) {
    return "geom3" /* GEOM3 */;
  }
  if (jscad.geometries.geom2.isA(csg)) {
    return "geom2" /* GEOM2 */;
  }
  if (jscad.geometries.path2.isA(csg)) {
    return "path2" /* PATH2 */;
  }
  return "unknown" /* UNKNOWN */;
}
export function csgToObject3D(csg) {
  if (jscad.geometries.geom3.isA(csg)) {
    return geom3ToObject3D(csg);
  }
  if (jscad.geometries.geom2.isA(csg)) {
    return geom2ToObject3D(csg);
  }
  if (jscad.geometries.path2.isA(csg)) {
    return path2ToObject3D(csg);
  }
  console.warn("no conversion method for", csg);
}
